const validate = (value, maxDigits) => {
  // let another rule check if value is numeric or not !
  if (isNaN(value)) {
    return true
  }

  let parsedValue = value.toString()
  if (parsedValue.length > maxDigits) {
    return false
  }

  return true
}

export default {
  validate,
  getMessage: (field, maxDigits) => {
    return `The index can contain a maximum of ${maxDigits} digits`
  }
}
